module.exports = __webpack_public_path__ + "img/logo-light.fd57b352.png";